import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import { Getter, Mutation } from 'vuex-class';
import PaymentGateways from '@/plugins/graphql/queries/v2/active-payment-gateways.gql';
let PaymentOptionFormMixin = class PaymentOptionFormMixin extends mixins(FormMixin, FormValidationsMixin, RouterParamsAppMixin) {
    // Will be invoke upon clicking cancel button
    cancel() {
        this.$emit('cancel');
    }
    // Will be invoke on success create mutation
    success() {
        this.$emit('success');
    }
    syncPaymentGatewayCache(cache, option, gatewayUuid) {
        const params = {
            query: PaymentGateways,
            variables: { appUuid: this.appUUID || this.appUuid },
        };
        const { fetchAllActivePaymentGateways } = cache.readQuery(params);
        const edgesCopy = [...fetchAllActivePaymentGateways.edges];
        const matchedGateway = edgesCopy.find((cachedGateway) => {
            return cachedGateway.node.uuid === gatewayUuid;
        });
        if (!matchedGateway) {
            return;
        }
        matchedGateway.node.appPaymentOption = option;
        cache.writeQuery({
            ...params,
            data: {
                fetchAllActivePaymentGateways: {
                    ...fetchAllActivePaymentGateways,
                    edges: edgesCopy,
                },
            },
        });
    }
};
__decorate([
    Prop({ type: Object, default: () => ({}) })
], PaymentOptionFormMixin.prototype, "paymentGateway", void 0);
__decorate([
    Prop({ type: String, default: 'Payment' })
], PaymentOptionFormMixin.prototype, "label", void 0);
__decorate([
    Prop({ type: String, default: 'Payment Name' })
], PaymentOptionFormMixin.prototype, "paymentName", void 0);
__decorate([
    Getter('requestOnFlight')
], PaymentOptionFormMixin.prototype, "requestCurrentlyOnFlight", void 0);
__decorate([
    Getter('appUuid')
], PaymentOptionFormMixin.prototype, "appUuid", void 0);
__decorate([
    Mutation('requestOnFlight')
], PaymentOptionFormMixin.prototype, "requestOnFlight", void 0);
__decorate([
    Mutation('requestDone')
], PaymentOptionFormMixin.prototype, "requestDone", void 0);
PaymentOptionFormMixin = __decorate([
    Component
], PaymentOptionFormMixin);
export default PaymentOptionFormMixin;
